export default function TaskCardLoader() {
    return (
        <>
            <div className="card pt-3 pb-1 ps-3 pe-3 shadow p-lg-4 mb-4 placeholder-glow ">
                <div className="row ms-lg-3">
                    <div className="col-12 col-sm-12 placeholder placeholder-sm col-lg-2"></div>
                    <div className="col-lg-3"></div>
                    <div className="col-4 col-sm-4 col-lg-1 placeholder placeholder-xs ps-4 ps-sm-4"></div>
                    <div className="col-lg-3"></div>
                    <div className="col-8 col-sm-8 col-lg-2 placeholder placeholder-xs pe-4 pe-sm-4"></div>
                </div>
                <div className="col-8 placeholder placeholder-xs mt-3 mb-3 ms-3"></div>
                <div className="row me-3 ms-3">
                    <div className="col-lg-2 placeholder placeholder-xs"></div>
                    <div className="col-lg-7"></div>
                    <div className="col-lg-3 placeholder placeholder-xs"></div>
                </div>
            </div>

        </>
    )
}